import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { for: "localeSelect" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("components.LocalePicker.localeLabel")), 1),
    _createElementVNode("select", {
      id: "localeSelect",
      value: _ctx.locale,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.localeSelection && _ctx.localeSelection(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (loc) => {
        return (_openBlock(), _createElementBlock("option", {
          key: loc,
          value: loc
        }, _toDisplayString(_ctx.$t(`locales.${loc}`)), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2)
  ]))
}